import { Header, Lore, About, Roadmap, Team, Faq } from '../containers';
import { SimpsContent, Footer, MobileNavbar } from '../components';
import AboutPage from './About';

const Simps = () => {
    return(
    <div className="w-screen text-center select-none">
        <SimpsContent />
    </div>
    )};
  
  export default Simps;